export default __webpack_public_path__ + "static/media/downloadIcon.e8d995f8.svg";